import React from 'react';
import ProjectList from '../components/ProjectList';

const Posts = () => {
  return (
    <div className="pt-16">
      <ProjectList />
    </div>
  );
};

export default Posts;
